import * as React from 'react';

function SvgClose(props) {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        d="M2 2L14 14"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={props.color}
      />
      <path
        d="M2 14L14 2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={props.color}
      />
    </svg>
  );
}

export default SvgClose;
